const BASE = '/magazine';
const LIST = `${BASE}/list`;
const QUESTIONS = `${BASE}/questions`;
const MY_COLLECTION = `${BASE}/my/collection`;
const AUTH_API = `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/api`;
const WISHKET_CDN = process.env.NEXT_PUBLIC_APP_WISHKET_CDN_URL;
const CANONICAL_BASE_URL =
  process.env.NEXT_PUBLIC_APP_BASE_URL === 'https://yozm.wishket.com'
    ? 'https://yozm.wishket.com'
    : process.env.NEXT_PUBLIC_APP_BASE_URL;

const PATH = Object.freeze({
  ROOT: '/',
  HOME: BASE,
  SLACKBOT: `${BASE}/slackbot`,
  DISCORD: 'https://discord.com/invite/Adm82XpF4c',
  SIGNUP_VERIFY: `${BASE}/signup/verify/`,
  AUTHORS: `${BASE}/authors`,
  QUESTIONS: QUESTIONS,
  QUESTIONS_SHARE: `${QUESTIONS}/share`,
  LIST: LIST,
  LIST_NEW: `${LIST}/new`,
  LIST_POPULAR: `${LIST}/popular`,
  LIST_PLAN: `${LIST}/plan`,
  LIST_DESIGN: `${LIST}/design`,
  LIST_DEVELOP: `${LIST}/develop`,
  LIST_PRODUCT: `${LIST}/product`,
  LIST_OUTSOURCING: `${LIST}/outsourcing`,
  LIST_FREELANCING: `${LIST}/freelancing`,
  LIST_BUSINESS: `${LIST}/business`,
  LIST_ITSERVICE: `${LIST}/itservice`,
  LIST_SEARCH: `${LIST}/search`,
  DETAIL: `${BASE}/detail`,
  AUTH_LOGIN: `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/login`,
  AUTH_LOGOUT: `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/logout`,
  AUTH_SIGNUP: `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/signup`,
  AUTH_SETTINGS: `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/settings`,
  AUTH_API: AUTH_API,
  AUTH_TERMS_PRIVACY: `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/terms/privacy`,
  AUTH_TERMS_SERVICE: `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/terms/service`,
  AUTH_TERMS_YOUTH_PROTECTION: `${process.env.NEXT_PUBLIC_APP_AUTH_URL}/terms/youth-protection`,
  WISHKET_OIDC_URL: `${AUTH_API}/oidc/access`,
  WISHKET_OIDC_ACTIVATION_URL: `${AUTH_API}/oidc/activation`,
  WISHKET_OIDC_LEGACY_INTERFACE_URL: `${AUTH_API}/oidc/legacy-interface`,
  YOZM_INTRODUCE:
    'https://wishket-team.notion.site/About-IT-199807d58f2e80cd9e2df37248cc73ff',
  YOZM_CONTENTS_PROPOSAL:
    'https://docs.google.com/forms/d/e/1FAIpQLScE-VVO4gNoVtz2nKJjA6_FqQ7DYy5g7bPIwahc12PeBbOoUA/viewform',
  YOZM_ADVERTISEMENT:
    'https://wishket-team.notion.site/IT-YOZM-IT-AD-1ce807d58f2e80b2bb41df4e076f8557',
  YOZM_AUTHOR_APPLY: 'https://answer.moaform.com/answers/WyvXJe',
  COLLECTION: `${BASE}/collection`,
  MY_COLLECTION: MY_COLLECTION,
  MY_COLLECTION_LIST: `${MY_COLLECTION}/list`,
  MY_COLLECTION_SCRAP: `${MY_COLLECTION}/scrap`,
  MY_COLLECTION_DETAIL: `${MY_COLLECTION}/detail`,
  MY_COLLECTION_CURRENT: `${MY_COLLECTION}/current`,
  MY_COLLECTION_HIGHLIGHT: `${MY_COLLECTION}/highlight`,
  NOTIFICATION_SETTINGS: `${BASE}/setting/notification/email/`,
  CHROME_EXTENSION_INSTALL:
    'https://chrome.google.com/webstore/detail/%EC%9A%94%EC%A6%98it/apbolfnadgepomiacibgiiflpmjglfgo?hl=ko&authuser=1',
  MEDIA_YOZM_IMAGE: `${process.env.NEXT_PUBLIC_APP_BASE_MEDIA_URL}/images/yozm`,
  PROFILE_SKILL: `${WISHKET_CDN}/skills.json`,
  COLLECTION_KEYWORD: `${WISHKET_CDN}/yozmit/static/collection_tag_keyword.json`,
  COLLECTION_FILTER_TAG: `${WISHKET_CDN}/yozmit/static/collection_filter_tag.json`,
  CANONICAL_BASE_URL,
});

export default PATH;
